import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { Account } from "api/mappers/accountMapper";
import { useCallback, useEffect, useState } from "react";
import { DISCOUNT_TIER } from "api/interfaces/subscription.interface";
import { checkWhiteSpaceRegEx } from "utils/regEx";
import {
  LEVEL_TYPE,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import { Option } from "utils/options";
import { EditAccountInfo, UPDATE_TYPE } from "../detail/AccountDetailContainer";
import { shouldClearDiscountValidation } from "utils/AccountUtil";
import { useAppSelector } from "redux/hooks";
import EditModalPresenter from "./EditModalPresenter";
import useApiError from "hook/useApiError";

interface Props {
  onClickSave: () => void;
  accountInfo: Account;
  editAccountInfo: EditAccountInfo;
  onChangeAccountInfo: (
    type: UPDATE_TYPE,
    value: number | string | boolean
  ) => void;
  logoHandleChange: (e: any) => void;
  logoImage: string;
  isUpdateLoading: boolean;
  isUpdateDisabled: boolean;
  validateMsg: ValidateMsg;
  accountAdmins: Option[];
  enableTransfer?: boolean;
  setValidateMsg: React.Dispatch<React.SetStateAction<ValidateMsg>>;
  onSave: () => void;
  setEditAccountInfo: React.Dispatch<React.SetStateAction<EditAccountInfo>>;
  onModal?: (type?: string) => void;
  uploadingLogo: boolean;
}
export default function EditModalContainer(props: Props) {
  const { editAccountInfo, setValidateMsg, onSave, setEditAccountInfo } = props;
  const [isTransferModal, setIsTransferModal] = useState<boolean>(false);
  const { lang, intlString } = useApiError();
  const [page, setPage] = useState<number>(0);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const isDw = selectedAccount.accountLevel === LEVEL_TYPE.DW;

  const onValidate = () => {
    if (checkWhiteSpaceRegEx(editAccountInfo.name)) {
      setValidateMsg((msg) => {
        return {
          ...msg,
          name: intlString(lang.validateMsg.account.name),
        };
      });

      return true;
    }

    return false;
  };
  const onChangePage = (name: string, index?: number) => {
    if (name === "next") {
      if (page === 0) {
        if (onValidate()) {
          return;
        }
      }
      setValidateMsg((msg) => {
        return {
          ...msg,
          name: "",
        };
      });
      setPage(page + 1);
    }
    if (name === "previous") {
      setPage(page - 1);
    }
    if (name === "save") {
      onSave();
    }
    if (name === "step" && index !== undefined) {
      if (page === 0 && index === 1) {
        if (onValidate()) {
          return;
        }
      }
      setValidateMsg((msg) => {
        return {
          ...msg,
          name: "",
        };
      });
      setPage(index);
    }
  };

  const onChangePricing = useCallback(
    (name: string, value: DISCOUNT_TIER | number | undefined) => {
      if (shouldClearDiscountValidation(name, value)) {
        setValidateMsg((info) => {
          return {
            ...info,
            discount: "",
          };
        });
      }
      setEditAccountInfo((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    },
    [setEditAccountInfo, setValidateMsg]
  );

  useEffect(() => {
    if (props.validateMsg.name !== "") {
      setPage(0);
    }
  }, [editAccountInfo.name, props.validateMsg.name]);
  return (
    <EditModalPresenter
      {...props}
      isDw={isDw}
      page={page}
      onChangePage={onChangePage}
      onChangePricing={onChangePricing}
      isTransferModal={isTransferModal}
      setIsTransferModal={setIsTransferModal}
    />
  );
}
